import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { IntlProvider } from 'react-intl'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

import messages from './messages'
import { flattenMessages, getParameterLanguage } from './utils'
const locale = getParameterLanguage()
ReactDOM.render(
  <React.StrictMode>
    <IntlProvider locale={locale} messages={flattenMessages(messages[locale])} key={locale}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </IntlProvider>
  </React.StrictMode>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
